import * as React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import LinearProgress from "@material-ui/core/LinearProgress";
import { IconButton, TablePagination, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import { Close } from "@material-ui/icons";

export interface IUnidentifiedProductsGridProps {
  error: string | null;
  loading: boolean;
  rows?: any[];
  items: Array<{ header: string; row: string }>;
  tableProps: {
    limit: number;
    page: number;
    total: number;
  };
  tooltipTitle: string;
  dialogTitle: string;
  dialogContent: string;
  onViewRow(row: any): void;
  handleChangePage(ev: any, page: number): void;
}

export interface IUnidentifiedProductsGridState {
  dialogOpen: boolean;
  rowToDelete: any;
}

export class UnidentifiedProductsGrid extends React.Component<
  IUnidentifiedProductsGridProps,
  IUnidentifiedProductsGridState
> {
  constructor(props: IUnidentifiedProductsGridProps) {
    super(props);
    this.state = {
      dialogOpen: false,
      rowToDelete: null,
    };
  }

  public render() {
    const { error, rows, handleChangePage, items, loading, tableProps } =
      this.props;
    const { limit, page, total } = tableProps;
    return (
      <div>
        {loading ? (
          <LinearProgress />
        ) : (
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  {items.map((v) => (
                    <TableCell key={this.getKey()}>{v.header}</TableCell>
                  ))}
                  <TableCell>Ações</TableCell>
                </TableRow>
              </TableHead>
              {!error && rows && rows.length > 0 && (
                <TableBody>
                  {rows.map((row: any, index) => (
                    <TableRow key={index}>
                      {items.map((v) => (
                        <TableCell key={this.getKey()}>{row[v.row]}</TableCell>
                      ))}
                      <TableCell>
                        <Tooltip title={this.props.tooltipTitle}>
                          <IconButton onClick={() => this.handleOpenDialog(row)}>
                            <Close />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
            <TablePagination
              component="div"
              page={page}
              count={total}
              rowsPerPage={limit}
              rowsPerPageOptions={[]}
              backIconButtonProps={{
                "aria-label": "Previous Page",
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page",
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={undefined}
            />
            <Dialog open={this.state.dialogOpen} onClose={this.handleCloseDialog}>
              <DialogTitle>{this.props.dialogTitle}</DialogTitle>
              <DialogContent>
                <p>{this.props.dialogContent}</p>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.handleDeleteItem()} color="primary">
                  Confirmar
                </Button>
                <Button onClick={this.handleCloseDialog} color="primary">
                  Cancelar
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        )}
      </div>
    );
  }

  private getKey = () => {
    return Math.random() * 12;
  };

  private handleOpenDialog = (row: any) => {
    this.setState({
      dialogOpen: true,
      rowToDelete: row,
    });
  };

  private handleCloseDialog = () => {
    this.setState({
      dialogOpen: false,
      rowToDelete: null,
    });
  };

  private handleDeleteItem = () => {
    this.props.onViewRow(this.state.rowToDelete);
    this.handleCloseDialog();
  };
}



// WEBPACK FOOTER //
// ./src/component/administration/unidentified-products-list/UnidentifiedProductsGrid.tsx